import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import apiClient from "../../../../../helpers/api-client";
import { PaginationInfo } from "../../../../../types/general-types";

export type Course = {
	id: string;
	name: string;
	code?: string;
};

export type VerityCourse = {
	id: number;
	uuid: string;
};

const coursesApi = createApi({
	reducerPath: "courses",
	baseQuery: async (arg, api, extraOptions) =>
		fetchBaseQuery({
			baseUrl: `/`,
			fetchFn: apiClient.fetch.bind(apiClient),
		})(arg, api, extraOptions),
	tagTypes: ["Course", "VerityCourse"],
	endpoints: (builder) => ({
		getCourses: builder.query<
			{ courses: Course[] } & PaginationInfo,
			{
				instituteId?: string;
				name?: string;
				size?: number;
				page?: number;
			}
		>({
			query: ({ instituteId, name, size = 6, page = 0 }) => {
				const searchParams = new URLSearchParams();
				searchParams.set("size", String(size));
				searchParams.set("page", String(page));
				if (instituteId) {
					searchParams.set("instituteId", instituteId);
				}
				if (name) {
					searchParams.set("name", name);
				}
				return `api/access-control/course?${searchParams.toString()}`;
			},
			providesTags: (result) =>
				result ? [...result.courses.map(({ id }) => ({ type: "Course" as const, id })), "Course"] : ["Course"],
		}),
		getCourse: builder.query<Course, string>({
			query: (id) => `api/access-control/course/${id}`,
			providesTags: (result) => (result ? [{ type: "Course" as const, id: result.id }] : ["Course"]),
		}),
		getVerityCourse: builder.query<VerityCourse, string>({
			query: (uuid) => `api/verity/course/uuid:${uuid}`,
			providesTags: (result) => (result ? [{ type: "VerityCourse" as const, id: result.uuid }] : ["VerityCourse"]),
		}),
	}),
});

export default coursesApi;
